export const isFetching = (state) => state.goHomeWith.isFetching;
export const groups = (state) => state.goHomeWith.groups;
export const selectedGoHomeWithChildId = (state) => state.goHomeWith.selectedGoHomeWithChildId;
